import React, { useState } from 'react';
import CodeEditor from './components/CodeEditor';
import './App.css';

function App() {
  const [feedback, setFeedback] = useState(null);

  const handleSubmitCode = (feedbackData) => {
    setFeedback(feedbackData); 
  };

  const handleHeaderClick = () => {
    window.location.href = './';
  };

  return (
    <div className="App-container">
      <header>
        <h1 className="gradient-text-header" onClick={handleHeaderClick} style={{ cursor: 'pointer' }}>
          CodeMentor
        </h1>
      </header> 
      <main>
        <CodeEditor onSubmitCode={handleSubmitCode} />
      </main>
    </div>
  );
}

export default App;
